import React from 'react';
import './footer.css';

const Footer: React.FC = () => {
  return (
    <footer>
      <p>© {new Date().getFullYear()} Conglomerator $ Co. All rights reserved.</p>
      <a
        href="https://www.tycoonland.nyc/privacy" 
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
      >
        Privacy & Terms of Services
      </a>
    </footer>
  );
};

export default Footer;